/**
 * Web stub for react-native-url-polyfill/auto
 * This is a side-effect import that polyfills URL globally
 */

// URL is already available in browsers, so no polyfill needed
if (typeof global !== 'undefined') {
  (global as any).URL = URL;
  (global as any).URLSearchParams = URLSearchParams;
}

export {};
